import { showActivateTokenState } from '@/atoms';
import { useActivateToken } from '@/services/tokens';
import { Button, Group, Text } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { ModalLayout } from 'moh-ui';
import { useQueryClient } from 'react-query';
import { useRecoilState } from 'recoil-next';

export default function ActivateTokenModal() {
   const [show, setShow] = useRecoilState(showActivateTokenState);
   const queryClient = useQueryClient();
   const { mutate: activateToken, isLoading } = useActivateToken();

   const handleClose = () => {
      setShow(null);
   };

   const handleActivate = () => {
      if (show?.token) {
         activateToken(show.token.id, {
            onSuccess: () => {
               queryClient.invalidateQueries('tokens');
               showNotification({
                  title: 'Success',
                  message: 'Token activated successfully',
                  color: 'green',
               });
               handleClose();
            },
            onError: (error) => {
               showNotification({
                  title: 'Error',
                  message: error.message || 'Failed to activate token',
                  color: 'red',
               });
            },
         });
      }
   };

   return (
      <ModalLayout open={Boolean(show?.show)} onClose={handleClose} size="md">
         <h2 className="text-xl font-semibold">Activate Token</h2>
         <Text mt="md">Are you sure you want to activate this token?</Text>
         <Group mt="xl">
            <Button variant="outline" onClick={handleClose} disabled={isLoading}>
               Cancel
            </Button>
            <Button color="green" onClick={handleActivate} loading={isLoading}>
               Activate
            </Button>
         </Group>
      </ModalLayout>
   );
}
